import { apiClient } from './setupApi';

const bonuses = '/bonuses';
const bonusCard = '/bonuses/card';

export const requestGetTemplateList = async (payload) => {
  const { data } = await apiClient.get(`${bonuses}/mailing`, {
    params: {
      ...payload
    }
  });
  return data;
};

export const requestGetGroupedTemplateList = async () => {
  const { data } = await apiClient.get(`${bonuses}/mailing/grouped`);
  return data;
};

export const requestCreateTemplate = async (payload) => {
  const { data } = await apiClient.post(`${bonuses}/mailing`, payload);
  return data;
};

export const requestGetTemplate = async (id) => {
  const { data } = await apiClient.get(`${bonuses}/mailing/${id}`);
  return data;
};

export const requestDeleteTemplate = async (id) => {
  const { data } = await apiClient.delete(`${bonuses}/mailing/${id}`);
  return data;
};

export const requestUpdateTemplate = async (id, payload) => {
  const { data } = await apiClient.patch(`${bonuses}/mailing/${id}`, payload);
  return data;
};

export const requestChangeTemplateStatus = async (id, payload) => {
  const { data } = await apiClient.patch(`${bonuses}/mailing/${id}/status`, payload);
  return data;
};

export const requestGetTimeBounds = async () => {
  const { data } = await apiClient.get(`${bonuses}/mailing/time-bounds`);
  return data;
}

export const requestGetMailingTriggers = async () => {
  const { data } = await apiClient.get(`${bonuses}/mailing/triggers`);
  return data;
}

export const requestBonusCardMailingTemplates = async (id, payload) => {
  const { data } = await apiClient.get(`${bonusCard}/${id}/mailing`, {
    params: { ...payload }
  });
  return data;
}

export const requestGetMailingListForBonusCard = async (id) => {
  const { data } = await apiClient.get(`${bonusCard}/${id}/mailing`);
  return data;
};

export const requestCreateMailingForBonusCard = async (id, payload, isActive) => {
  const path = `${bonusCard}/${id}/${isActive ? 'active' : 'create'}/mailing`;
  const { data } = await apiClient.post(path, payload);
  return data;
};

export const requestUpdateMailingForBonusCard = async (id, mailingId, payload) => {
  const { data } = await apiClient.patch(`${bonusCard}/${id}/mailing/${mailingId}`, {...payload });
  return data;
};

export const requestDeleteMailingForBonusCard = async (id, mailingId, isActive) => {
  const path = `${bonusCard}/${id}/${isActive ? 'active' : 'create'}/mailing/${mailingId}`;
  const { data } = await apiClient.delete(path);
  return data;
};
